import { doc, getFirestore, onSnapshot } from 'firebase/firestore'
import { StatusType } from 'models/extensions'
import { ResponseLive, transformLives } from 'models/lives-store/utils'
import { useStores } from 'models/root-store'
import { useEffect } from 'react'

type RedButtonConfig = { shouldRedirect: boolean; lives: ResponseLive[] }

export const useRedButtonConfigSync = () => {
  const {
    livesStore: { setLives, setFromRedirect, setStatus },
  } = useStores()
  useEffect(() => {
    const docRef = doc(getFirestore(), 'settings', 'redButton')
    setStatus(StatusType.PENDING)
    const unsubscribe = onSnapshot(docRef, async (document) => {
      const data = document.data() as RedButtonConfig | undefined
      const lives = data?.lives ? await transformLives(data.lives) : []
      setLives(lives)
      setFromRedirect(data?.shouldRedirect || false)
      setStatus(StatusType.DONE)
    })
    return unsubscribe
  }, [setFromRedirect, setLives, setStatus])
}
